<div class="finance-awards-accelerator-view-part">
	<grid-content [setup]="setup" [namedSize]="'TabContent'" [pageTabsGridSize]="pageTabsGridSize()"
		[rows]="acceleratorCourseAssignments()"></grid-content>
</div>